import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var DEFAULT_LAYOUT_PROPS = {
  horizontal: false,
  horizontalBreakpoint: 'xs',
  horizontalLabelWidth: 160,
  horizontalLabelOffset: undefined
};
export var DefaultLayoutContext = /*#__PURE__*/createContext(DEFAULT_LAYOUT_PROPS);
/**
 * This context provider sets the default layout options of all nested
 * `FormField` components so that these options don't have to be
 * repeated for each field.
 */

export function DefaultFormFieldLayout(_ref) {
  var children = _ref.children,
    layoutProps = _objectWithoutProperties(_ref, _excluded);
  var mergedLayoutProps = _objectSpread(_objectSpread({}, DEFAULT_LAYOUT_PROPS), layoutProps);
  return /*#__PURE__*/_jsx(DefaultLayoutContext.Provider, {
    value: mergedLayoutProps,
    children: children
  });
}

/**
 * Provides access to any default layout options defined on a parent
 * `DefaultFormFieldLayout` component so that they don't have to be
 * specified for each field individually.
 *
 * Local props (those passed into the hook) will override the defaults.
 */

export function useDefaultFormFieldLayout(localProps) {
  var _localProps$horizonta, _localProps$horizonta2, _localProps$horizonta3;
  var layoutDefaults = useContext(DefaultLayoutContext);
  return {
    horizontal: (_localProps$horizonta = localProps.horizontal) !== null && _localProps$horizonta !== void 0 ? _localProps$horizonta : layoutDefaults.horizontal,
    horizontalBreakpoint: (_localProps$horizonta2 = localProps.horizontalBreakpoint) !== null && _localProps$horizonta2 !== void 0 ? _localProps$horizonta2 : layoutDefaults.horizontalBreakpoint,
    horizontalLabelWidth: localProps.horizontalLabelWidth || layoutDefaults.horizontalLabelWidth,
    horizontalLabelOffset: (_localProps$horizonta3 = localProps.horizontalLabelOffset) !== null && _localProps$horizonta3 !== void 0 ? _localProps$horizonta3 : layoutDefaults.horizontalLabelOffset
  };
}